import React from 'react'
import { LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { Step2 } from './Step2'
import type { Step2Props } from './Step2'
import { Step2Legacy } from './Step2Legacy'

export const Step2Wrapper: React.FC<Step2Props> = props => {
  const isUnifiedMarkAllItemFulfillmentEnabled = getFeatureFromCache(
    LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT
  )

  return isUnifiedMarkAllItemFulfillmentEnabled ? (
    <Step2 {...props} />
  ) : (
    <Step2Legacy {...props} />
  )
}

export { Step2Wrapper as Step2 }
export type { Step2Props }
